export default __webpack_public_path__ + "media/mock/src/img/blognoimage-8c009f3a0bb83cf553de4b8352d7712e.png";